"use client";

import React, { useState } from "react";
import { Form, Button, Row, Col, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const BusinessForm = () => {
  const [formData, setFormData] = useState({
    propertyName: "",
    hotelLocation: "",
    rooms: "",
    projectStatus: "",
    usp: "",
    yourName: "",
    ownerType: "",
    contactNumber: "",
    email: "",
    aboutProperty: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Container>
        <div className="business-form">
          <h2 className="mb-4 text-center !text-[23px]">Get In Touch</h2>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Name Of The Property"
                    name="propertyName"
                    value={formData.propertyName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Hotel Location"
                    name="hotelLocation"
                    value={formData.hotelLocation}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Number of Rooms"
                    name="rooms"
                    value={formData.rooms}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="New Built / Running / Under Project"
                    name="projectStatus"
                    value={formData.projectStatus}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="USP (Unique Selling Proposition)"
                name="usp"
                value={formData.usp}
                onChange={handleChange}
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Your Name"
                    name="yourName"
                    value={formData.yourName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="You Are Owner / Broker"
                    name="ownerType"
                    value={formData.ownerType}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Contact Number"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="About Property"
                name="aboutProperty"
                value={formData.aboutProperty}
                onChange={handleChange}
              />
            </Form.Group>
            <div className="text-center">
              <Button
                type="submit"
                style={{
                  backgroundColor: "#f04e02",
                  border: "none",
                  color: "white",
                  fontSize: "12px",
                }}
              >
                SUBMIT
              </Button>
            </div>
          </Form>
        </div>
      </Container>
      <style jsx>{`
        .business-form h2 {
          font-weight: 600;
          margin-bottom: 20px;
          textalign: center;
        }

        .business-form input,
        .business-form textarea {
          border-radius: 0px;
          font-size: 13px;
        }

        .business-form button {
          padding: 8px 30px;
          border-radius: 2px;
          font-size: 12px;
          font-weight: 500;
        }

        .business-form textarea {
          resize: none;
        }
      `}</style>
    </>
  );
};

export default BusinessForm;
